const Genders = [
    {id: 1, name: "Male"},
    {id: 2, name: "Female"},
    {id: 3, name: "Prefer not to say"}
]

export default Genders;